import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import * as articleCategoryActions from "../../../actions/articleCategoryActions";
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";
import WithResolvedPromises from "../../common/WithResolvedPromises";
import PlaceholderTable from "../../common/PlaceholderTable";
import PlaceholderError from "../../common/PlaceholderError";
import {messages} from "../../common/Translations";
import {Link} from "react-router-dom";
import MediaQuery from "react-responsive";
import ArticleCategoryListDivs from "./ArticleCategoryListDivs";
import ArticlesCategoriesList from "./ArticlesCategoriesList";
import BaseList from "../../common/list/BaseList";
import {toastr} from "react-redux-toastr";
import CustomModal from "../../CustomModal";
import * as modalActions from '../../../actions/common/modalActions';
import ArticleCategoryTableRow from "./ArticleCategoryTableRow";
import {plainJSTranslator} from "../../../common/PlainJSTranslator";
import CompanyPortalSelect from "../../company/list/CompanyPortalSelect";
import * as portalActions from '../../../actions/portal-contact/portalActions';


class ArticleCategoriesListContainer extends BaseList {

    constructor(props) {
        super(props);
        this.listId = 'articleCategories';
        this.idToDelete = null;

        this.state = {
            showDeleteModal: false,
            actions: this.getRequiredActions(),
            deleteMessage: this.props.intl.formatMessage(messages.articleCategoryDeleteQuestion),
            showDeleted: true,
            selectedPortal: '',
            showTable: true
        };

        this.onDelete = this.onDelete.bind(this);
        this.onReactivate = this.onReactivate.bind(this);
        this.onPortalChange = this.onPortalChange.bind(this);
        this.onShowDeletedClick = this.onShowDeletedClick.bind(this);
    }

    getRequiredActions() {
        return [
            this.props.actions.loadCategories({}, true),
            this.props.actions.loadPortals()
        ]
    }

    onDelete(category) {
        this.idToDelete = category.id;
        if(category.totalAmountInArticles > 0) {
            this.setState({deleteMessage: this.props.intl.formatMessage(messages.articleCategoryListWarningArticlesAmount,
                    {amount: category.totalAmountInArticles})});
        } else {
            this.setState({deleteMessage: this.props.intl.formatMessage(messages.articleCategoryDeleteQuestion)});

        }
        this.props.actions.showModal();
    }



    onReactivate(id) {
        this.props.actions.reactivateArticleCategory(id).then(() => {
            toastr.success(this.props.intl.formatMessage(messages.articleCategoryMessageStatusActivated));
        });
    }

    confirmDelete() {
        this.setState({showTable: false});
        if (this.idToDelete !== null) {
            this.props.actions.deleteArticleCategory(this.idToDelete).then(() => {
                this.setState({showTable: true});
                this.idToDelete = null;
                this.props.actions.hideModal();
                toastr.success(this.props.intl.formatMessage(messages.articleCategoryDeleted));
            });
        } else {
            toastr.error(this.props.intl.formatMessage(messages.articleCategoryDeleteError));
            this.props.actions.hideModal();
        }
    }

    hideDeleteModal() {
        this.idToDelete = null;
        this.props.actions.hideModal();
    }

    onPortalChange(portalId) {
        this.setState({showTable: false});
        this.props.actions.loadCategories({portalId}, this.state.showDeleted).then(() => {
            this.setState({showTable: true})
        });
        this.setState({selectedPortal: portalId});
    }

    onShowDeletedClick() {
        this.setState({showTable: false});
        this.props.actions.loadCategories({portalId: this.state.selectedPortal}, !this.state.showDeleted).then(() => {
            this.setState({showTable: true})
        });
        this.setState({showDeleted: !this.state.showDeleted});
    }

    render() {
        return (
            <WithResolvedPromises
                promises={this.state.actions}
                preloaderComponent={PlaceholderTable}
                errorComponent={PlaceholderError}
            >
                {
                    addActions => {
                        return (
                            <div>
                                <CustomModal
                                    modalTitle={this.props.intl.formatMessage(messages.articleCategoryDelete)}
                                    modalContent={
                                        <p>{this.state.deleteMessage}</p>}
                                    confirmText={this.props.intl.formatMessage(messages.deleteModalConfirmButton)}
                                    closeText={this.props.intl.formatMessage(messages.deleteModalCancelButton)}
                                    handleConfirm={() => {
                                        this.confirmDelete()
                                    }}
                                />
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card m-b-20">
                                            <div className="card-block">
                                                <div className='row'>
                                                    <div className="col-sm-6">
                                                        <h1 className="mb-3">
                                                            {this.props.intl.formatMessage(messages.articleCategoriesList)}
                                                        </h1>
                                                    </div>
                                                    <div className="col-sm-6 pt-2">
                                                        <Link
                                                            to="/kategorier/nyheder/skab"
                                                            className="btn btn-primary waves-effect pull-right"
                                                        >
                                                            {this.props.intl.formatMessage(messages.articleCategoryCreateButton)}
                                                        </Link>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-6">
                                                        <CompanyPortalSelect
                                                            sortableList={{}}
                                                            portals={this.props.portals}
                                                            onPortalSelect={this.onPortalChange}
                                                        />
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <button
                                                            onClick={this.onShowDeletedClick}
                                                            className={`btn btn-primary pull-right waves-effect`}>
                                                            {
                                                                this.state.showDeleted ?
                                                                    this.props.intl.formatMessage(messages.articleCategoryShowDeactivatedButton) :
                                                                    this.props.intl.formatMessage(messages.articleCategoryHideDeactivatedButton)
                                                            }
                                                        </button>
                                                    </div>
                                                </div>
                                                {
                                                    this.state.showTable ? (<table className="table">
                                                    <thead>
                                                    <tr>
                                                    <th scope="col">#</th>
                                                    <th scope="col">{this.props.intl.formatMessage(messages.articleCategoryListName)}</th>
                                                    <th scope="col">{this.props.intl.formatMessage(messages.articleCategoryListPortalLabel)}</th>
                                                    <th scope="col">{this.props.intl.formatMessage(messages.articleCategoryListDescription)}</th>
                                                    <th scope="col">{this.props.intl.formatMessage(messages.articleCategoryListStatus)}</th>
                                                    <th scope="col">{this.props.intl.formatMessage(messages.articleCategoryListOptions)}</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {this.props.categories.map(category => {
                                                        return (
                                                            <ArticleCategoryTableRow
                                                                key={category.id}
                                                                category={category}
                                                                onDelete={this.onDelete}
                                                                onRestore={this.onReactivate}
                                                            />
                                                        );
                                                    })}
                                                    </tbody>
                                                    </table>)
                                                        : <PlaceholderTable showButtons={false}/>
                                                }


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )

                    }
                }

            </WithResolvedPromises>
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        categories: state.articleCategories,
        sortableList: state.sortableList,
        articleCategory: state.articleCategory,
        portals: state.portals
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                articleCategoryActions,
                portalActions,
                modalActions
            ), dispatch)
    }

}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ArticleCategoriesListContainer));



// WEBPACK FOOTER //
// ./web/src/components/articles/category/ArticleCategoriesListContainer.jsx